export default "__VITE_ASSET__BIVfx4yj__"